import { AsyncButton, Input } from '@bpinternal/ui-kit-next'
import { useState } from 'react'
import { useSetPromoCode } from '~/features/billing/hooks/useSetPromoCode'
import { useSuspenseQuery } from '~/services'

type PromoCodeSectionProps = {
  workspaceId: string
}

export const PromoCodeSection = ({ workspaceId }: PromoCodeSectionProps) => {
  const {
    data: { billingReadonly },
  } = useSuspenseQuery('workspaces_/$workspaceId_/billing/info', { workspaceId })
  const { mutate: updatePromoCode, isPending: isUpdatingPromoCode } = useSetPromoCode({ workspaceId })

  const [promoCodeInput, setPromoCodeInput] = useState<string>()

  return (
    <div>
      <div className="pb-4 font-medium">Promo Code</div>
      <div className="flex gap-2">
        <Input
          placeholder="Enter Promo Code"
          value={promoCodeInput}
          onChange={(e) => setPromoCodeInput(e.target.value)}
        ></Input>
        <AsyncButton
          disabled={!promoCodeInput || billingReadonly || isUpdatingPromoCode}
          loading={isUpdatingPromoCode}
          onClick={() => {
            if (promoCodeInput) {
              updatePromoCode({ code: promoCodeInput })
            }
          }}
          className="bg-primary"
        >
          Apply
        </AsyncButton>
      </div>
    </div>
  )
}
